import React from 'react';

import { Button, Text } from '@schoolinks/ui-components';

import { func, string } from 'prop-types';

import ModalV2 from 'components/Common/ModalV2';

import s from './BackToDashboard.css';

const BackToDashboard = ({ onClose, dashboardUrl }) => (
  <ModalV2
    open
    onClose={onClose}
    title="Back to dashboard"
    dialogClasses={{ root: s.content }}
    classes={{ paper: s.paper }}
    actions={
      <>
        <Button
          label="Cancel"
          color="secondary"
          variant="text"
          onClick={onClose}
        />
        <Button
          color="secondary"
          variant="outlined"
          href={dashboardUrl}
          onClick={onClose}
          label="Go back to Dashboard"
        />
      </>
    }
  >
    <>
      <Text isBold mb={2} variant="lead400">
        Are you sure you want to go back?
      </Text>
      <Text variant="lead400">You will lose any unsaved changes.</Text>
    </>
  </ModalV2>
);

BackToDashboard.propTypes = {
  onClose: func.isRequired,
  dashboardUrl: string.isRequired,
};

export default BackToDashboard;
